import { render, staticRenderFns } from "./PpmAdditionalDocuments.vue?vue&type=template&id=e246e2da"
import script from "./PpmAdditionalDocuments.vue?vue&type=script&lang=ts"
export * from "./PpmAdditionalDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports